/**
 * Workspace-only multi-member picker — the shared MemberSearch in multi mode (LOGIN-TO-TENANT.md §8.1): chips +
 * server-side search from 2 letters, any workspace size. Thin wrapper so release co-supervisors and pool-level agent
 * supervisor overrides keep their props.
 */
import React from 'react';
import MemberSearch from './MemberSearch.jsx';

export default function WorkspaceMembersMultiPicker({
  value,
  onChange,
  tenantId,
  excludeEmails,
  placeholder,
  emptyHint,
  disabled = false,
}) {
  return (
    <MemberSearch mode="multi" tenantId={tenantId} value={Array.isArray(value) ? value : []}
      onChange={(list) => onChange?.(list)} excludeEmails={excludeEmails || []}
      placeholder={placeholder || 'Type a name or email to add members…'} emptyHint={emptyHint || ''}
      disabled={disabled} ariaLabel="Workspace members" testId="members-multi-search" />
  );
}
